import apiClient from "./api";
import { Metadata } from "../types";
import { getFromCache, setToCache, cacheFirst } from "../storage/cacheManager";

const METADATA_CACHE_KEY = "metadata:app";
const METADATA_CACHE_EXPIRY = 30 * 60 * 1000;

class MetadataService {
  async getMetadata(): Promise<Metadata> {
    const cached = await getFromCache<Metadata>(METADATA_CACHE_KEY);
    if (cached) {
      return cached;
    }

    if (!navigator.onLine) {
      console.warn("Offline mode: metadata not available in cache");
      throw new Error("Metadata not available offline");
    }

    const fetchData = async (): Promise<Metadata> => {
      await new Promise((resolve) => setTimeout(resolve, 100));

      const response = await apiClient.get<Metadata>("/Metadata");
      const metadata = response.data;
      await setToCache(METADATA_CACHE_KEY, metadata, METADATA_CACHE_EXPIRY);
      return metadata;
    };

    return cacheFirst(METADATA_CACHE_KEY, fetchData, METADATA_CACHE_EXPIRY);
  }
}

export const metadataService = new MetadataService();

export type { Metadata };
export const getMetadata = () => metadataService.getMetadata();
